import { createSelector } from 'reselect';
import { ServiceTimeClass } from '@mews/enums';
import { getContainer } from '@mews-commander/legacy-app-instance';
import { getDefaulTimesByBookablePeriod } from './utils';

export const getDefaulLocalizedTimes = (bookablePeriod?: ServiceTimeClass) =>
    createSelector(getContainer, (container) => {
        const {
            appLocalizationComponent: { localizeToShortTimeString },
        } = container();

        const { arrivalTime, departureTime } = getDefaulTimesByBookablePeriod(bookablePeriod);

        return {
            arrivalTime: localizeToShortTimeString(arrivalTime),
            departureTime: localizeToShortTimeString(departureTime),
        };
    });
